<ds-header
  [navBarRef]="navBar"
  appName="Transport Quality Control (TQC.Next)"
  [environmentTag]="environmentTagConfig()"
  [userInfo]="userInfo()"
  (requestLogout)="logout()"
  [menuTemplate]="isImpersonating() ? extraOptionsTemplate : null"
>
</ds-header>
<ng-template #extraOptionsTemplate>
  @if (isImpersonating()) {
    <ds-menu-item
      icon="user_add"
      [isHoverable]="true"
      (click)="stopImpersonation()"
      (keydown.enter)="stopImpersonation()"
    >
      {{ 'header.stopImpersonation' | translate }}
    </ds-menu-item>
  }
</ng-template>
<div class="d-flex">
  <div class="nav-bar-wrapper position-sticky">
    <ds-navigation-bar
      class="nav-bar-wrapper position-sticky"
      #navBar
      [items]="navigationItems()"
      [metaItems]="metaItems()"
    ></ds-navigation-bar>
  </div>
  <div class="flex-grow-1 p-1x content-area d-flex flex-column">
    <div class="d-flex flex-column flex-grow-1 content-outlet">
      <tqc-header></tqc-header>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<tqc-error-toast></tqc-error-toast>
